import api from "./api";

function toParams({ page, pageSize, search, sortBy, sortOrder, ...rest } = {}) {
    const params = { ...rest };
    if (page) params.page = page;
    if (pageSize) params.page_size = pageSize;
    if (search) params.search = search;
    if (sortBy) params.sort_by = sortBy;
    if (sortOrder) params.sort_order = sortOrder;
    return params;
}

export const financeService = {
    async meta() {
        const { data } = await api.get("/finance/meta");
        return data;
    },
    async dashboard() {
        const { data } = await api.get("/finance/dashboard");
        return data;
    },
    async listAccounts(query = {}) {
        const { data } = await api.get("/finance/accounts", { params: toParams(query) });
        return data;
    },
    async getAccount(id) {
        const { data } = await api.get(`/finance/accounts/${id}`);
        return data;
    },
    async createAccount(payload) {
        const { data } = await api.post("/finance/accounts", payload);
        return data;
    },
    async patchAccount(id, payload) {
        const { data } = await api.patch(`/finance/accounts/${id}`, payload);
        return data;
    },
    async cancelAccount(id, payload = {}) {
        const { data } = await api.post(`/finance/accounts/${id}/cancel`, payload);
        return data;
    },
    async registerPayment(id, payload) {
        const { data } = await api.post(`/finance/accounts/${id}/payments`, payload);
        return data;
    },
    async listSuppliers(query = {}) {
        const { data } = await api.get("/finance/suppliers", { params: toParams(query) });
        return data;
    },
    async createSupplier(payload) {
        const { data } = await api.post("/finance/suppliers", payload);
        return data;
    },
    async patchSupplier(id, payload) {
        const { data } = await api.patch(`/finance/suppliers/${id}`, payload);
        return data;
    },
    async deleteSupplier(id) {
        await api.delete(`/finance/suppliers/${id}`);
    },
};
